import type {PropsWithChildren} from 'react';
import classnames from 'classnames';

import styles from './styles.module.css';

export const ActionsRow = ({children}: PropsWithChildren) => {
    return (
        <div className={classnames(styles.row)}>
            {children}
        </div>
    );
};
